import type {
  BingEventParams,
  TpBingEventName,
} from '@features/Analytics/types/bing';
import { useCallback, useMemo } from 'react';
import { retry } from 'src/utils';

export type BingEventPayload = {
  eventName: TpBingEventName;
  options?: BingEventParams;
};

export const useBingEvent = () => {
  const conditionCheckFunction = useCallback(
    async () => window?.uetq != null,
    [],
  );

  const fetchClientEventWithRetry = useCallback(
    async ({ eventName, options = {} }: BingEventPayload) => {
      const actionFunction = async () => {
        window.uetq = window.uetq || [];
        window.uetq.push('event', eventName, options);
      };

      await retry({
        conditionCheckFunction,
        actionFunction,
        retryDelay: 300,
      });
    },
    [conditionCheckFunction],
  );

  return useMemo(
    () => ({
      clientEvent: ({ eventName, options }: BingEventPayload) => {
        fetchClientEventWithRetry({ eventName, options });
      },
    }),
    [fetchClientEventWithRetry],
  );
};
